module.exports = __webpack_public_path__ + "img/green.5e2c7f91.png";